import { useMutation } from '@tanstack/react-query'

import { convertToPdfRequest } from './request'

export const useConvertToPdfMutation = () =>
  useMutation({
    mutationFn: convertToPdfRequest
  })
